export default __webpack_public_path__ + "static/media/cleaning-window-shine.995e98b0.svg";